import React from 'react'

import { isMobile } from '../../../global/browser'
import SimpleWaitingRoomScreenComponent from '../SimpleWaitingRoomScreenComponent/SimpleWaitingRoomScreenComponent'
import MediaWaitingRoomScreenComponent from '../MediaWaitingRoomScreenComponent/MediaWaitingRoomScreenComponent'
import { useWaitingRoomType } from '../../useAudienceLiveState'

import './WebinarAudienceWaitingRoomComponent.scss'

const WebinarAudienceWaitingRoomComponent = () => {
  const waitingRoomType = useWaitingRoomType()
  const isMobileDevice = isMobile()

  const content =
    waitingRoomType === 'simple' ? (
      <SimpleWaitingRoomScreenComponent isMobileDevice={isMobileDevice} />
    ) : (
      <MediaWaitingRoomScreenComponent isMobileDevice={isMobileDevice} />
    )

  return (
    <div className="webinar-audience-waiting-room-component">{content}</div>
  )
}

// oxlint-disable-next-line import/no-default-export
export default WebinarAudienceWaitingRoomComponent

export { WebinarAudienceWaitingRoomComponent }
